module.exports = __webpack_public_path__ + "static/media/img_29.fdeddb33.png";